import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as TurnUpIcon } from "../../assets/icons/user2/turnupright.svg";
import { ReactComponent as WalkIcon } from "../../assets/icons/user2/walk.svg";

const places = [
  {
    id: 1,
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR4w275GUDXN-foFddPGxExUMD9xzNLNzVpKw&s",
    name: "หน่วยตรวจฉุกเฉินและบริการ",
    floor: "ชั้น 2",
    building: "อาคารสุจิณโณ",
    distance: "50 m",
    direction: "ห่างออกไป",
    detail:
      "หน่วยตรวจฉุกเฉิน (Emergency Room - ER) ชั้น 1 อาคารเฉลิมพระบารมี เปิดบริการ 24 ชั่วโฒง สำหรับภาวะฉุกเฉินเร่งด่วน",
  },
];

export default function MobileMenuList() {
  const [selected, setSelected] = useState(null);
  const { t, i18n } = useTranslation();
  const isEn = i18n.language === "en";

  const translatedPlaces = places.map((item) => {
    if (!isEn) return item;
    return {
      ...item,
      name: "Emergency Room and Services",
      floor: "Floor 2",
      building: "Su Jinno Building",
      direction: "Away",
      detail:
        "Emergency Room (ER) Floor 1, Chalermprakiat Building, open 24 hours for emergency and urgent cases.",
    };
  });

  return (
    <div className="font-sans">
      {/* Title */}

      <p className=" text-slate-500 text-lg mt-6 ml-4">{t("user.menuList.searchResults")}</p>
      <div className="space-y-3">
        {translatedPlaces.map((item) => (
          <button
            key={item.id}
            onClick={() => setSelected(item)}
            className="w-full border-t border-b bg-white p-3 mt-2 shadow flex items-center "
          >
            <img
              src={item.image}
              alt={item.name}
              className="w-20 h-16 rounded-lg object-cover mr-1"
            />
            <div className="flex items-start justify-between p-2">
              {/* ฝั่งซ้าย */}
              <div className="min-w-0 flex-1 text-left mr-8">
                <div className="text-lg font-semibold text-slate-900 truncate">
                  {item.name}
                </div>
                <div className="text-base text-slate-500 mt-1">
                  {item.floor} - {item.building}
                </div>
              </div>

              {/* ฝั่งขวา */}
              <div className="shrink-0 text-right">
                <div className="flex text-lg font-medium text-blue-700">
                  <WalkIcon className="mr-1 w-6 h-6"/>
                  {item.distance}
                </div>
                <div className="text-base text-slate-500 mt-1">
                  {item.direction}
                </div>
              </div>
            </div>
          </button>
        ))}
      </div>
      <BottomSheet
        open={!!selected}
        onClose={() => setSelected(null)}
        item={selected}
      />
    </div>
  );
}

function BottomSheet({ open, onClose, item }) {
  const sheetRef = useRef(null);
  const startYRef = useRef(0);
  const currentYRef = useRef(0);
  const draggingRef = useRef(false);
  const { t } = useTranslation();

  const [translateY, setTranslateY] = useState(0);

  useEffect(() => {
    if (open) {
      setTranslateY(0);
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  if (!open || !item) return null;

  const startDrag = (clientY) => {
    draggingRef.current = true;
    startYRef.current = clientY;
    currentYRef.current = translateY;
  };

  const onDrag = (clientY) => {
    if (!draggingRef.current) return;

    const delta = clientY - startYRef.current;
    if (delta < 0) {
      setTranslateY(0);
      return;
    }

    setTranslateY(delta);
  };

  const endDrag = () => {
    if (!draggingRef.current) return;
    draggingRef.current = false;

    if (translateY > 120) {
      setTranslateY(400);
      setTimeout(() => {
        onClose();
        setTranslateY(0);
      }, 250);
    } else {
      setTranslateY(0);
    }
  };

  const handleMouseDown = (e) => startDrag(e.clientY);
  const handleMouseMove = (e) => onDrag(e.clientY);
  const handleMouseUp = () => endDrag();

  const handleTouchStart = (e) => startDrag(e.touches[0].clientY);
  const handleTouchMove = (e) => onDrag(e.touches[0].clientY);
  const handleTouchEnd = () => endDrag();

  return (
    <div className="fixed inset-0 z-50">
      <div className="absolute inset-0 " onClick={onClose} />

      <div
        ref={sheetRef}
        className="absolute bottom-0 left-0 right-0 h-[50vh] rounded-t-lg bg-white shadow-2xl border-2 border-slate-200 overflow-hidden touch-none"
        style={{
          transform: `translateY(${translateY}px)`,
          transition: draggingRef.current ? "none" : "transform 0.25s ease-out",
        }}
        onMouseMove={handleMouseMove}
        onMouseUp={handleMouseUp}
        onMouseLeave={handleMouseUp}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        <div
          className="flex justify-center pt-3 pb-2 cursor-grab active:cursor-grabbing"
          onMouseDown={handleMouseDown}
          onTouchStart={handleTouchStart}
        >
          <div className="h-1.5 w-14 rounded-full bg-slate-300" />
        </div>

        <div className="h-full overflow-y-auto px-4 pb-8">
          <div className="items-start gap-3 pt-2">
            <img
              src={item.image}
              alt={item.name}
              className="w-full h-32 rounded-2xl object-cover"
            />
            <div className="flex-1">
              <div className="text-2xl font-medium mt-4 m-2">{item.name}</div>
              <div className="flex m-2 justify-between">
                <div className="flex items-center">
                  <div className="px-4 text-lg py-1 bg-blue-50 border border-blue-600 rounded-xl text-blue-600">
                    {item.floor}
                  </div>
                  <div className="ml-4 m-2 text-slate-700 text-lg">{item.building}</div>
                </div>
                <div className="text-lg flex font-medium text-blue-700 mt-2">
                  <WalkIcon className="w-6 h-6 mr-1"/>
                  {item.distance}
                </div>
              </div>
            </div>
          </div>

          <div className="m-2 mt-3">
            <div className="text-xl font-semibold text-slate-900">{t("user.menuList.description")}</div>
            <p className="mt-1 text-lg leading-6 text-slate-600">
              {item.detail}
            </p>
          </div>

          <div className="flex items-center">
            <button className="flex text-xl font-medium items-center justify-center p-3 rounded-lg bg-blue-600 w-full mt-1 mb-1 text-white">
              <TurnUpIcon className="m-2 w-5 h-5"/>{t("user.menuList.startNavigation")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
